module.exports = __webpack_public_path__ + "img/bus.0198b6da.svg";